import { render } from "./TabsNav.vue?vue&type=template&id=e78f65c4&scoped=true"
import script from "./TabsNav.vue?vue&type=script&lang=js"
export * from "./TabsNav.vue?vue&type=script&lang=js"

import "./TabsNav.vue?vue&type=style&index=0&id=e78f65c4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e78f65c4"]])

export default __exports__